export interface ServicePartnersSearch {
  readonly page: number;
  readonly q?: string;
  readonly chain?: string;
}

export function parseServicePartnersSearch(
  search: Record<string, unknown>,
): ServicePartnersSearch {
  const page = Number(search.page);
  return {
    page: Number.isSafeInteger(page) && page >= 1 ? page : 1,
    q: typeof search.q === "string" ? search.q.trim() || undefined : undefined,
    chain:
      typeof search.chain === "string" && search.chain.trim()
        ? search.chain
        : undefined,
  };
}
